import { render, staticRenderFns } from "./RecruitPost.vue?vue&type=template&id=5bf471dc&scoped=true&"
import script from "./RecruitPost.vue?vue&type=script&lang=js&"
export * from "./RecruitPost.vue?vue&type=script&lang=js&"
import style0 from "./RecruitPost.vue?vue&type=style&index=0&id=5bf471dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf471dc",
  null
  
)

export default component.exports